"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SearchCondition = _interopRequireDefault(require("01_core/components/layout/SearchCondition"));
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CMultiToggle = _interopRequireDefault(require("01_core/components/materials/CMultiToggle"));
var _SelectKaishaSoshiki = _interopRequireDefault(require("01_core/components/select/SelectKaishaSoshiki"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _APIs = require("01_core/constants/APIs");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _windowUtil = _interopRequireDefault(require("01_core/logics/windowUtil"));
var _coreInfoBarActions = require("01_core/reducers/coreInfoBarActions");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
var _SelectKansaTgtNendo = _interopRequireDefault(require("../../common/components/select/SelectKansaTgtNendo"));
var _kansaConditionActions = require("../../common/kansaConditionActions");
var _kansaReportActions = require("../kansaReportActions");
var Yup = _interopRequireWildcard(require("yup"));
var _useRHFForm = require("01_core/validation/useRHFForm");
var _validationHelpers = require("01_core/validation/validationHelpers");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 監査報告書検索画面（検索条件）
 */
function KansaReportSearchCondition(props) {
  var _errors$kansaTgtNendo;
  const {
    intl,
    callAPI,
    openInfoBar,
    closeInfoBar,
    changeSearchCondition,
    initConditionKansaTgtNendo,
    initConditionHikansabumon,
    saveShareCondition,
    fixConditions,
    setSearchResult,
    loginUserInfo,
    searchConditions,
    search,
    hikansabumonInitialized,
    inParentCompany,
    getCodeItems,
    pms
  } = props;
  const areaRef = (0, _react.useRef)(null);

  // RHF defaultValues
  const defaultValues = (0, _react.useMemo)(() => {
    var _searchConditions$cre, _searchConditions$eva;
    return {
      kansaTgtNendo: searchConditions !== null && searchConditions !== void 0 && searchConditions.kansaTgtNendo ? String(searchConditions.kansaTgtNendo) : '',
      creationStsCd: (_searchConditions$cre = searchConditions === null || searchConditions === void 0 ? void 0 : searchConditions.creationStsCd) !== null && _searchConditions$cre !== void 0 ? _searchConditions$cre : '',
      evaluationStsCd: (_searchConditions$eva = searchConditions === null || searchConditions === void 0 ? void 0 : searchConditions.evaluationStsCd) !== null && _searchConditions$eva !== void 0 ? _searchConditions$eva : ''
    };
  }, [searchConditions]);

  // RHF＋Yup スキーマ
  const shape = (0, _react.useMemo)(() => ({
    kansaTgtNendo: (0, _validationHelpers.requiredSelect)(intl),
    creationStsCd: Yup.string().nullable(),
    evaluationStsCd: Yup.string().nullable()
  }), [intl]);

  // RHF
  const {
    handleSubmit,
    setValue,
    formState
  } = (0, _useRHFForm.useRHFForm)({
    defaultValues,
    shape
  });
  const {
    errors
  } = formState;

  // 監査対象年度変更
  const handleChangeKansaTgtNendo = (0, _react.useCallback)((kansaTgtNendo, kansaThemeNm) => {
    changeSearchCondition('kansaTgtNendo', kansaTgtNendo);
    changeSearchCondition('kansaThemeNm', kansaThemeNm);
    setValue('kansaTgtNendo', String(kansaTgtNendo), {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [changeSearchCondition, setValue]);

  // 監査対象年度 初期値
  const handleSetInitialNendo = (0, _react.useCallback)((kansaTgtNendo, kansaThemeNm) => {
    initConditionKansaTgtNendo(kansaTgtNendo, kansaThemeNm);
    setValue('kansaTgtNendo', String(kansaTgtNendo), {
      shouldValidate: false,
      shouldDirty: true
    });
  }, [initConditionKansaTgtNendo, setValue]);

  // 被監査部門（親会社の場合のみ選択）
  const handleChangeHikansabumon = (0, _react.useCallback)(_ref => {
    let {
      kaishaCd,
      soshikiCd,
      label
    } = _ref;
    changeSearchCondition('hikansabumonKaishaCd', kaishaCd);
    changeSearchCondition('hikansabumonSoshikiCd', soshikiCd);
    changeSearchCondition('hikansabumon', label);
  }, [changeSearchCondition]);

  // MultiToggle変更
  const handleSearchConditionChange = (0, _react.useCallback)(key => value => changeSearchCondition(key, value), [changeSearchCondition]);

  // API実行
  const executeSearchAPI = (0, _react.useCallback)(sendData => {
    callAPI(_APIs.KANSA_REPORT_SEARCH, sendData).then(json => {
      if (json.status === _APIs.STATUS.SUCCESS) {
        setSearchResult(json.data);
        if (json.data.length === 0) {
          openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.INFO, intl.formatMessage({
            id: _labelConsts.LABEL.CORE_NO_SEARCH_RESULT_MESSAGE
          }));
        } else {
          if (!search) {
            _windowUtil.default.scrollBelowElement(areaRef.current);
          }
        }
      }
    });
  }, [callAPI, setSearchResult, openInfoBar, intl, search]);

  // 検索ボタン押下
  const onSearchClick = (0, _react.useCallback)(() => {
    if (!search) {
      saveShareCondition(searchConditions);
      fixConditions();
      closeInfoBar();
    }
    executeSearchAPI(searchConditions);
  }, [search, saveShareCondition, searchConditions, fixConditions, closeInfoBar, executeSearchAPI]);

  // 初期化（親会社の被監査部門ラベル）を一度だけ
  (0, _react.useEffect)(() => {
    if (!hikansabumonInitialized) {
      initConditionHikansabumon(loginUserInfo.kaishaCd, loginUserInfo.kaishaNm);
    }
  }, [hikansabumonInitialized, initConditionHikansabumon, loginUserInfo]);

  // 検索済みフラグがtrueなら、マウント時や戻り時に再検索を実行
  (0, _react.useEffect)(() => {
    if (search) {
      onSearchClick();
    }
  }, [search, onSearchClick]);

  // 条件UIの組み立て
  const hikansabumon = inParentCompany ? /*#__PURE__*/_react.default.createElement(_SelectKaishaSoshiki.default, {
    kansaTgtNendo: searchConditions.kansaTgtNendo,
    kaishaCd: searchConditions.hikansabumonKaishaCd,
    soshikiCd: searchConditions.hikansabumonSoshikiCd,
    lv2limit: true,
    titleText: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON
    }),
    buttonText: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON_SELECT
    }),
    label: searchConditions.hikansabumon,
    onChange: handleChangeHikansabumon,
    pms: pms
  }) : /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_HI_KANSA_BUMON
    })
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, searchConditions.hikansabumon));
  const nendoCondition = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SelectKansaTgtNendo.default, {
    isSelectable: true,
    kansaTgtNendo: searchConditions.kansaTgtNendo,
    onChange: handleChangeKansaTgtNendo,
    setInitialValue: (kansaTgtNendo, kansaThemeNm) => {
      handleSetInitialNendo(kansaTgtNendo, kansaThemeNm);
    },
    isMsgHidden: true
  }), !!errors.kansaTgtNendo && /*#__PURE__*/_react.default.createElement(_FormHelperText.default, {
    error: true
  }, (_errors$kansaTgtNendo = errors.kansaTgtNendo) === null || _errors$kansaTgtNendo === void 0 ? void 0 : _errors$kansaTgtNendo.message));
  const conditions = [nendoCondition, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_AUDIT_THEME
    })
  }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    variant: "body2"
  }, searchConditions.kansaThemeNm)), hikansabumon, /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_CREATION_STATUS
    })
  }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
    options: getCodeItems(_CodeConsts.CODE.KANSA_RP_CRESTS.KBN),
    selectedOption: searchConditions.creationStsCd,
    onSelectOption: handleSearchConditionChange('creationStsCd')
  })), /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_REPORT_EVALUATION_STATUS
    })
  }, /*#__PURE__*/_react.default.createElement(_CMultiToggle.default, {
    options: getCodeItems(_CodeConsts.CODE.KANSA_RP_EVSTS.KBN),
    selectedOption: searchConditions.evaluationStsCd,
    onSelectOption: handleSearchConditionChange('evaluationStsCd')
  }))];

  // 送信（onValid）
  const onValid = (0, _react.useCallback)(() => {
    onSearchClick();
  }, [onSearchClick]);

  // 送信（onInvalid）
  const onInvalid = (0, _react.useCallback)(() => {
    openInfoBar(_coreInfoBarActions.INFOBAR_VARIANT.ERROR, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_VALIDATE_MESSAGE
    }));
  }, [openInfoBar, intl]);
  return /*#__PURE__*/_react.default.createElement("form", {
    noValidate: true,
    onSubmit: handleSubmit(onValid, onInvalid)
  }, /*#__PURE__*/_react.default.createElement("div", {
    ref: areaRef
  }, /*#__PURE__*/_react.default.createElement(_SearchCondition.default, {
    conditions: conditions,
    validate: true,
    returnHome: true
  })));
}
const mapStateToProps = state => {
  return {
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    searchConditions: state.kansaReport.searchConditions,
    searchResult: state.kansaReport.searchResult,
    search: state.kansaReport.search,
    kansaTgtNendoInitialized: state.kansaReport.kansaTgtNendoInitialized,
    hikansabumonInitialized: state.kansaReport.hikansabumonInitialized,
    inParentCompany: state.kansaReport.inParentCompany,
    previousContent: state.kansaReport.containerInfo.previousContent
  };
};
const mapDispatchToProps = dispatch => {
  return {
    changeSearchCondition: (key, value) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.CHANGE_SEARCH_CONDITION](key, value)),
    initConditionKansaTgtNendo: (kansaTgtNendo, kansaThemeNm) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.INIT_CONDITION_KANSA_TGT_NENDO](kansaTgtNendo, kansaThemeNm)),
    initConditionHikansabumon: (kaishaCd, hikansabumon) => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.INIT_CONDITION_HIKANSABUMON](kaishaCd, hikansabumon)),
    fixConditions: () => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.FIX_CONDITIONS]()),
    setSearchResult: resultList => dispatch(_kansaReportActions.kansaReportActions[_kansaReportActions.TYPES.SET_SEARCH_RESULT](resultList)),
    openInfoBar: (type, message) => dispatch(_kansaReportActions.kansaReportActions[_coreInfoBarActions.TYPES_INFO_BAR.OPEN](type, message)),
    closeInfoBar: () => dispatch(_coreInfoBarActions.coreInfoBarActions[_coreInfoBarActions.TYPES_INFO_BAR.CLOSE]()),
    saveShareCondition: condition => dispatch(_kansaConditionActions.kansaConditionActions[_kansaConditionActions.TYPES_CONDITION.SAVE](condition))
  };
};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)((0, _CodeUtil.withCodeUtil)(KansaReportSearchCondition))));